import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Label, Table } from 'react-bootstrap';
import { FormattedNumber, injectIntl } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { findIndex as _findIndex } from 'lodash';

import { getNameInCurrentLanguage } from 'helpers/intl';

import Breadcrumb from 'components/layout/Breadcrumb';
import Loader from 'components/layout/Loader';
import IntlDateTime from 'components/layout/IntlDateTime';
import IntlDate from 'components/layout/IntlDate';
import ClientListInfo from 'components/layout/ClientListInfo';

import IntlFormInlineSelector from 'components/intlForm/IntlFormInlineSelector';

import List from 'components/List';

class OrderListEmployee extends React.Component {
  // change the url to display order information
  handleRowClick = detailsUrl => {
    const { history } = this.props;
    history.push(detailsUrl);
  };

  getBreadcrumb = () => {
    const {
      intl: { messages },
      appIntl,
    } = this.props;

    return (
      <Breadcrumb
        crumbs={[{ link: appIntl.urlPrefix + 'account', name: 'Dashboard' }, { link: null, name: messages.orders }]}
      />
    );
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      list,
    } = this.props;

    const columns = [
      messages.client,
      messages.order,
      messages.status,
      messages.authorization_status,
      messages.date,
      messages.salesDoc.total_due,
      messages.actions,
    ];
    const tBody = [];
    for (let i = 0; i < list.data.list.length; i++) {
      const order = list.data.list[i];
      const {
        id,
        type,
        cdate,
        target,
        sum_gross: sumGross,
        currency,
        lead_pipeline: pipeline,
        lead_current_stage: currentStage,
        date_from: dateFrom,
        date_to: dateTo,
        is_closed: isClosed,
        is_cancelled: isCancelled,
      } = order;

      const detailsUrl = appIntl.urlPrefix + 'account/orders/' + id;

      let currentProgress = 0;
      let countStages = 0;
      if (pipeline && currentStage) {
        currentProgress = _findIndex(pipeline.stages, ['id', currentStage]);
        countStages = pipeline.stages.length;
      }

      const progressElements = [];
      for (let j = 0; j < countStages; j++) {
        progressElements.push(
          <div class="pull-left" style={{ width: (1 / countStages) * 100 + '%' }} key={j}>
            <div
              class={'m-r-5 bg-' + (j <= currentProgress ? 'primary-light' : 'master-lighter')}
              style={{ height: '3px' }}
            />
          </div>
        );
      }
      let authorizationStatus = order.authorization_successful
        ? messages.authorized
        : order.authorization_rejected
        ? messages.not_authorized
        : messages.pending;
      tBody.push(
        <tr key={i} class="clickable" onClick={() => this.handleRowClick(detailsUrl)}>
          <td class="v-align-middle">
            <ClientListInfo client={target} />
          </td>
          <td class="v-align-middle">
            {isClosed ? (
              <div>
                <Label bsStyle="primary" class="block">
                  {messages.closed}
                </Label>
              </div>
            ) : null}
            {isCancelled ? (
              <div>
                <Label bsStyle="warning" class="block">
                  {messages.order_cancelled}
                </Label>
              </div>
            ) : null}
            <strong>ID:</strong> {id} <br />
            {messages.orderTypes[type]}
            {type === 'car_rent' ? (
              <span>
                <br />
                <IntlDate date={dateFrom} /> - <IntlDate date={dateTo} />
              </span>
            ) : null}
          </td>
          <td class="v-align-middle">
            {!!progressElements.length && (
              <React.Fragment>
                <div class="clearfix m-b-10">{progressElements}</div>
                <IntlFormInlineSelector />
                {getNameInCurrentLanguage(pipeline.stages[currentProgress].name, appIntl)}
              </React.Fragment>
            )}
          </td>
          <td class="v-align-middle">{authorizationStatus}</td>
          <td class="v-align-middle">
            <IntlDateTime date={cdate} />
          </td>
          <td class="v-align-middle">
            <FormattedNumber value={sumGross} style="currency" currency={currency} />
          </td>
          <td class="v-align-middle text-right">
            <Link to={detailsUrl} class="btn-rounded btn btn-sm btn-default">
              <i class="fa fa-pencil-alt" /> {messages.edit}
            </Link>
          </td>
        </tr>
      );
    }

    const resultTable = list.pending ? (
      <Loader />
    ) : (
      <Table responsive hover className="orderList">
        <thead>
          <tr>
            {columns.map((column, i) => {
              return (
                <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <ReactCSSTransitionGroup
          transitionName="tablerows"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={1}
          component="tbody"
        >
          {tBody}
        </ReactCSSTransitionGroup>
      </Table>
    );

    return (
      <List
        listName="orders"
        url="/api/orders.json"
        list={list}
        title={messages.orders}
        iconClass="fa fa-shopping-bag"
        showNew={false}
        newText={messages.add_order}
        newAction={this.showNew}
        showSearch
        sortOptions={['cdate,desc', 'mdate,desc', 'name,asc']}
        breadcrumb={this.getBreadcrumb()}
        metaIdentifier="Order:Order"
      >
        {resultTable}
      </List>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.orders,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(OrderListEmployee)));
